import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';

import { getLoginRedirectQuery } from './auth.flow';
import type { AppRole } from './auth.models';
import { AuthStore } from './auth.store';

const roleRank: Record<AppRole, number> = {
  EMPLOYEE: 1,
  STORE_ADMIN: 2,
  SUPER_ADMIN: 3
};

const redirectToLogin = (router: Router, returnUrl?: string): UrlTree => {
  return router.createUrlTree(['/login'], {
    queryParams: getLoginRedirectQuery(returnUrl)
  });
};

const redirectToHome = (router: Router): UrlTree => {
  return router.createUrlTree(['/']);
};

export const authGuard: CanActivateFn = (_route, state) => {
  const authStore = inject(AuthStore);
  const router = inject(Router);

  return authStore.isAuthenticated() ? true : redirectToLogin(router, state.url);
};

export const guestGuard: CanActivateFn = () => {
  const authStore = inject(AuthStore);
  const router = inject(Router);

  return authStore.isAuthenticated() ? router.createUrlTree(['/']) : true;
};

export const minimumRoleGuard = (minimumRole: AppRole): CanActivateFn => {
  return (_route, state) => {
    const authStore = inject(AuthStore);
    const router = inject(Router);
    const actor = authStore.actor();

    if (!authStore.isAuthenticated() || !actor) {
      return redirectToLogin(router, state.url);
    }

    return roleRank[actor.role] >= roleRank[minimumRole] ? true : redirectToHome(router);
  };
};
